
import { Component, Injector, Input, OnInit } from '@angular/core';
import { ComponentContextService,  DataFormBase,  EventData, FormSchemaBase,   TextControlSchema,
 SwitchControlSchema, DateTimeControlSchema } from 'tnx-shared';
import { LogSubscribeService } from 'tnx-admin-service/logsubscribe/services';

@Component({
    selector: 'logsubscribe-form',
    templateUrl: './logsubscribe-form.component.html',
    styleUrls: ['./logsubscribe-form.component.scss'],
    providers: [ComponentContextService],
})
export class LogSubscribeFormComponent extends DataFormBase implements OnInit {

    constructor(
        protected _injector: Injector,
        private _logSubscribeService: LogSubscribeService
    ) {
        super(_injector);
    }

    ngOnInit() {
        super.ngOnInit();
		this.setting.baseService = this._logSubscribeService;
        this.setting.schema = <FormSchemaBase[]>[
            	 new TextControlSchema({
				field: 'code',
				label: ''
			}),
			 new TextControlSchema({
				field: 'customActions',
				label: ''
			}),
			 new TextControlSchema({
				field: 'templateInstanceId',
				label: ''
			}),
			 new TextControlSchema({
				field: 'templateCode',
				label: ''
			}),
			 new SwitchControlSchema({
				field: 'enabled',
				label: 'Sử dụng'
			}),
			 new TextControlSchema({
				field: 'currentStateCode',
				label: ''
			})
        ];
    }

    async onFormInitialized(formEvent: EventData) {
       // tiền xử lý dữ liệu (ví dụ tổng hợp datasource), trước khi gọi api get detail
    }

    async onFormEvent(evt) {
        // các event trong form
        console.log(evt);
    }

    async modifyDetailData(data) {
        // xử lý dữ liệu lấy từ get detail về
    }

    async onAfterGetDetail() {
        // xử lý dữ liệu sau khi đã lấy từ api (sau cả event modifyDetailData) về và trước khi hiển thị ra view
    }

    onBeforeSave() {
        // trước khi lưu
    }
}

